import React from "react";
import { Translation } from "../../core/translate";
import { OffScreenComponent } from "../mixins";
import styled from "styled-components";

const OuterContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const SpinnerContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const CenteredSpinner = () => (
  <OuterContainer>
    <SpinnerContainer>
      <div className="spinning" />
    </SpinnerContainer>
    <OffScreenComponent>
      <Translation id="base.loading" />
    </OffScreenComponent>
  </OuterContainer>
);

export default CenteredSpinner;
